const standaloneLoginBrands = [
  'nuvoton', // 6901
  'essilorxnikon', // 7318
  'kyeckingyuan', // 7631
  'cylights', // 5754
];

export default standaloneLoginBrands;
